<template>
	<div id="rightTopDom" ref="autoHeight" style="height: 100%;position: relative;">
		<el-carousel :autoplay='false' trigger='click' style="height: 100%;" ref="carouselRef">
			<el-carousel-item v-for="item in 2" :key="item">
				<div v-if="item == 1" style="width: 100%%;height: 100%;">
					<div v-if="!nollData" id="echar1_1" ref="echar1_1" style="width: 100%;height: 100%;"></div>
					<div v-if="nollData" style="width: 100%;padding: 20px 0;font-size: 0.9vw;font-weight: 600;color: white;">
						<img src="../../../../static/imgV2/none.png" style="width: 30%;" alt="">
						<div style="margin-top: 10px;">{{ languageJson.noneEvent }}</div>
					</div>
				</div>
				<div v-else>
					<div id="map_2" style="position: absolute;width: 98%;height: 98%;display: flex;justify-content: center;align-items: center;top: 1%;left: 1%;">
						<div class="content-div-check"
							:style="{ width: vWidth + 'px', height: vHeight + 'px', zoom: mapScale}">
							<img :src="mapData.routeImg" />
							<div class="robot" ref="robot" v-for="(obj, $index) in mapRobotAry" :key="$index" :style="{ backgroundColor: mapRobotVal[$index].color, boxShadow: `0px 0px 0.5vw ${mapRobotVal[$index].color}` }">
							</div>
						</div>
					</div>
				</div>
			</el-carousel-item>
		</el-carousel>
	</div>
</template>

<script>
	import {
		mapEventType,
		eventThermogram
	} from '@/api/indexV2'
	import RobotMapLi from '@/components/RobotMapLi.vue'
	import {
		getItem
	} from '@/utils/auth'
	export default {
		data() {
			return {
				languageJson: languageJson,
				languageCheck: localStorage.getItem('language'),
				myChart_1: null,
				rightCheck: "0",
				mapData: {
					routeImg: "",
					positon: null
				},
				vHeight: 0,
				vWidth: 0,
				mapScale: 0,
				mapRobotAry: [],
				mapRobotVal: [],
				nollData: false,
				robotType: "",
				originX: "",
				originY: "",
				resolution: "",
				dataFloor: "",
				dataRouteId: ""
			}
		},
		components: {
			RobotMapLi
		},
		props: {
			timeStamp: Number,
			changeTime: Boolean,
			routeId: String,
			mapType: String,
			floor: String
		},
		updated() {
			let that = this
			if (that.$refs.robot && that.$refs.robot.length > 0) {
				that.$refs.robot.map((v, index) => {
					document.getElementsByClassName('robot')[index].style.width = 0.8 / that.mapScale + "vw"
					document.getElementsByClassName('robot')[index].style.height = 0.8 / that.mapScale + "vw"
					if (that.robotType == "04") {
						v.style.top = that.drawPointFun({ x: Number(that.mapRobotAry[index].split(',')[0]), y: Number(that.mapRobotAry[index].split(',')[1])})[1] - (10 / that.mapScale) + 'px'
						v.style.left = that.drawPointFun({ x: Number(that.mapRobotAry[index].split(',')[0]), y: Number(that.mapRobotAry[index].split(',')[1])})[0] - (10 / that.mapScale) + 'px'
					} else {
						v.style.top = Number(that.mapRobotAry[index].split(',')[1]) - (10 / that.mapScale) + 'px'
						v.style.left = Number(that.mapRobotAry[index].split(',')[0]) - (10 / that.mapScale) + 'px'
					}
				})
			}
		},
		mounted() {
			let that = this
			that.mapEventType(getItem('tenantInfoId'))
			that.eventThermogram(that.floor, that.routeId)
		},
		methods: {
			drawPointFun (rowInfo) {
				let that = this
				const mapX = Math.sqrt(Math.pow(rowInfo.x, 2));
				const mapOX = Math.sqrt(Math.pow(that.originX, 2));
				let ax = 0;
				if (rowInfo.x == 0) {
					ax = mapOX;
				} else if (rowInfo.x > 0) {
					ax = mapOX + mapX;
				} else if (rowInfo.x < 0) {
					ax = mapOX - mapX;
				}

				const mapH =  that.vHeight * that.resolution;
				const mapY =  Math.sqrt(Math.pow(rowInfo.y, 2));
				const mapOy = Math.sqrt(Math.pow(that.originY, 2));
				let ay = 0;
				if (rowInfo.y == 0) {
					ay = mapY;
				} else if (rowInfo.y > 0) {
					ay = mapH - mapOy - mapY;
				} else if (rowInfo.y < 0) {
					ay = mapH - mapOy + mapY;
				}

				ax = Number(ax / that.resolution);
				ay = Number(ay / that.resolution);
				return [ax, ay]
			},
			fontSizeCh(res) {
				// 获取屏幕宽度
				if (window.screen.width <= 1920) {
					return res
				} else if (window.screen.width > 1920 && window.screen.width <= 3200) {
					return res * 1.5
				} else if (window.screen.width > 3200 && window.screen.width <= 3840) {
					return res * 2.2
				} else if (window.screen.width > 3840) {
					return res * 3
				}
			},
			mapEventType(tId) {
				let that = this
				mapEventType(tId).then(res => {
					if (res && res.data.length > 0) {
						that.nollData = false
						let eventVal = []
						res.data.forEach(res => {
							eventVal.push({
								value: res.number,
								name: res.name
							})
						})
						var myChart = that.$echarts.init(document.getElementById('echar1_1'))
						that.myChart_1 = myChart
						let option = {
							legend: {
								top: 'bottom',
								textStyle: {
									color: '#ffffff',
									fontSize: that.fontSizeCh(11)
								}
							},
							tooltip: {
								trigger: 'item',
								formatter: '{b}: {c} ({d}%)',
								textStyle: {
									fontSize: that.fontSizeCh(14)
								}
							},
							series: [{
								type: 'pie',
								radius: ['10%', '50%'],
								center: ['50%', '40%'],
								avoidLabelOverlap: false,
								label: {
									formatter: '{b} {c} ({d}%)',
									textStyle: {
										fontSize: that.fontSizeCh(14)
									}
								},
								itemStyle: {
									borderRadius: 10,
									borderColor: '#fff',
									borderWidth: 2
								},
								emphasis: {
									label: {
										show: true,
										fontSize: 20,
										fontWeight: 'bold'
									}
								},
								itemStyle: {
									borderRadius: 8
								},
								data: eventVal
							}]
						};
						myChart.setOption(option)
					} else {
						that.nollData = true
					}
				})
			},
			eventThermogram(fId,rId) {
				let that = this
				that.mapRobotAry = []
				that.mapRobotVal = []
				if (rId) {
					eventThermogram({
						tenantInfoId: getItem('tenantInfoId'),
						routeId: rId,
						floor: that.mapType == "04" ? fId : ''
					}).then(res => {
						if (res && res.data) {
							that.mapData = res.data
							that.vWidth = Number(res.data.width)
							that.vHeight = Number(res.data.height)
							that.robotType = res.data.robotType
							if (res.data.robotType == '04') {
								that.originX = res.data.originX
								that.originY = res.data.originY
								that.resolution = res.data.resolution
							}
							for(let x in res.data.positon) {
								that.mapRobotAry.push(x.toString())
								if (Number(res.data.positon[x]) > 0 && Number(res.data.positon[x]) < 30) {
									that.mapRobotVal.push({
										color: '#8B0000'
									})
								} else if (Number(res.data.positon[x]) > 30 && Number(res.data.positon[x]) < 80) {
									that.mapRobotVal.push({
										color: '#8B0000'
									})
								} else if (Number(res.data.positon[x]) > 80) {
									that.mapRobotVal.push({
										color: '#660000'
									})
								}
							}
							that.computedScale()
						}
					})
				}
			},
			computedScale() {
				let that = this
				that.mapScale = 1
				that.$nextTick().then(() => {
					let oW = that.$refs.autoHeight.offsetWidth
					let oH = that.$refs.autoHeight.offsetHeight
					if (that.vWidth != oW || that.vHeight != oH) {
						let wScale = oW / that.vWidth;
						let hScale = oH / that.vHeight;
						that.mapScale = Math.min(wScale, hScale);
					}
				})
			}
		},
		watch: {
			floor: {
				deep: true,
				immediate: false,
				handler(newData, oldData) {
					if (newData) {
						this.dataFloor = newData
						this.eventThermogram(newData, this.dataRouteId)
					}
				}
			},
			routeId: {
				deep: true,
				immediate: false,
				handler(newData, oldData) {
					if (newData) {
						this.dataRouteId = newData
						this.eventThermogram(this.dataFloor, newData)
					}
				}
			},
			changeTime: {
				deep: true,
				immediate: false,
				handler(newData, oldData) {
					this.mapEventType(getItem('tenantInfoId'))
					this.eventThermogram(this.dataFloor, this.dataRouteId)
					if (this.rightCheck == '0') {
						this.$refs.carouselRef.setActiveItem('1')
						this.rightCheck = '1'
					} else {
						this.$refs.carouselRef.setActiveItem('0')
						this.rightCheck = '0'
					}
				}
			},
			timeStamp: {
				deep: true,
				immediate: true,
				handler(newData, oldData) {
					let that = this
					if (newData) {
						if (that.myChart_1) {
							that.myChart_1.resize()
							that.computedScale()
						}
					}
				}
			}
		}
	}
</script>

<style scoped lang="less">
	#rightTopDom /deep/ .el-carousel__container {
		height: 100%;
	}
	#rightTopDom /deep/ .robot {
		width: 30px;
		height: 30px;
	}

	#rightTopDom /deep/ .el-carousel__indicators--horizontal {
		display: none;
	}
</style>



// WEBPACK FOOTER //
// src/page/customIndex/components/rightCenter.vue